export type TilliXContentBlock =
  | { type: "paragraph"; key: string }
  | { type: "list"; introKey?: string; itemKeys: string[] }
  | { type: "subheading"; key: string }
  | { type: "link"; key: string; href: string };

export interface TilliXTermsSection {
  id: string;
  titleKey: string;
  content: TilliXContentBlock[];
}

const s = "terms.tilliXSections";

/** tilliX Terms & Conditions — sourced from tilli.pro. */
export const tillixTermsSections: TilliXTermsSection[] = [
  {
    id: "acceptance-of-terms",
    titleKey: `${s}.acceptanceOfTerms.title`,
    content: [
      { type: "paragraph", key: `${s}.acceptanceOfTerms.p1` },
      { type: "paragraph", key: `${s}.acceptanceOfTerms.p2` },
      { type: "paragraph", key: `${s}.acceptanceOfTerms.p3` },
    ],
  },
  {
    id: "products-and-services",
    titleKey: `${s}.productsAndServices.title`,
    content: [
      { type: "subheading", key: `${s}.productsAndServices.tilliXTitle` },
      { type: "paragraph", key: `${s}.productsAndServices.tilliXIntro` },
      {
        type: "list",
        itemKeys: [
          `${s}.productsAndServices.tilliXItem1`,
          `${s}.productsAndServices.tilliXItem2`,
          `${s}.productsAndServices.tilliXItem3`,
          `${s}.productsAndServices.tilliXItem4`,
        ],
      },
      { type: "subheading", key: `${s}.productsAndServices.nudgeTitle` },
      { type: "paragraph", key: `${s}.productsAndServices.nudgeIntro` },
      {
        type: "list",
        itemKeys: [
          `${s}.productsAndServices.nudgeItem1`,
          `${s}.productsAndServices.nudgeItem2`,
          `${s}.productsAndServices.nudgeItem3`,
          `${s}.productsAndServices.nudgeItem4`,
        ],
      },
      { type: "subheading", key: `${s}.productsAndServices.tilliPayTitle` },
      { type: "paragraph", key: `${s}.productsAndServices.tilliPayIntro` },
      {
        type: "list",
        itemKeys: [
          `${s}.productsAndServices.tilliPayItem1`,
          `${s}.productsAndServices.tilliPayItem2`,
          `${s}.productsAndServices.tilliPayItem3`,
          `${s}.productsAndServices.tilliPayItem4`,
        ],
      },
    ],
  },
  {
    id: "usage-rights-and-restrictions",
    titleKey: `${s}.usageRightsAndRestrictions.title`,
    content: [
      {
        type: "list",
        introKey: `${s}.usageRightsAndRestrictions.intro`,
        itemKeys: [
          `${s}.usageRightsAndRestrictions.item1`,
          `${s}.usageRightsAndRestrictions.item2`,
          `${s}.usageRightsAndRestrictions.item3`,
          `${s}.usageRightsAndRestrictions.item4`,
          `${s}.usageRightsAndRestrictions.item5`,
        ],
      },
    ],
  },
  {
    id: "payment-terms",
    titleKey: `${s}.paymentTerms.title`,
    content: [
      {
        type: "list",
        introKey: `${s}.paymentTerms.intro`,
        itemKeys: [
          `${s}.paymentTerms.item1`,
          `${s}.paymentTerms.item2`,
          `${s}.paymentTerms.item3`,
          `${s}.paymentTerms.item4`,
          `${s}.paymentTerms.item5`,
        ],
      },
      { type: "paragraph", key: `${s}.paymentTerms.closing` },
    ],
  },
  {
    id: "privacy-and-data-protection",
    titleKey: `${s}.privacyAndDataProtection.title`,
    content: [
      { type: "paragraph", key: `${s}.privacyAndDataProtection.p1` },
      {
        type: "list",
        introKey: `${s}.privacyAndDataProtection.listIntro`,
        itemKeys: [
          `${s}.privacyAndDataProtection.item1`,
          `${s}.privacyAndDataProtection.item2`,
          `${s}.privacyAndDataProtection.item3`,
          `${s}.privacyAndDataProtection.item4`,
        ],
      },
    ],
  },
  {
    id: "intellectual-property-rights",
    titleKey: `${s}.intellectualPropertyRights.title`,
    content: [
      { type: "paragraph", key: `${s}.intellectualPropertyRights.p1` },
      { type: "paragraph", key: `${s}.intellectualPropertyRights.p2` },
    ],
  },
  {
    id: "limitation-of-liability",
    titleKey: `${s}.limitationOfLiability.title`,
    content: [
      { type: "paragraph", key: `${s}.limitationOfLiability.p1` },
      { type: "paragraph", key: `${s}.limitationOfLiability.p2` },
    ],
  },
  {
    id: "termination",
    titleKey: `${s}.termination.title`,
    content: [
      {
        type: "list",
        introKey: `${s}.termination.intro`,
        itemKeys: [
          `${s}.termination.item1`,
          `${s}.termination.item2`,
          `${s}.termination.item3`,
        ],
      },
      { type: "paragraph", key: `${s}.termination.closing` },
    ],
  },
  {
    id: "contact-information",
    titleKey: `${s}.contactInformation.title`,
    content: [
      { type: "paragraph", key: `${s}.contactInformation.companyName` },
      { type: "paragraph", key: `${s}.contactInformation.department` },
      { type: "paragraph", key: `${s}.contactInformation.address` },
      { type: "paragraph", key: `${s}.contactInformation.email` },
      { type: "paragraph", key: `${s}.contactInformation.phone` },
      {
        type: "link",
        key: `${s}.contactInformation.contactPageText`,
        href: "https://tillisoftware.com/terms-and-conditions",
      },
    ],
  },
];
